import React from 'react'
import { withTranslation } from 'react-i18next'
import { MAP_SETTINGS_IMAGES } from '../../assets'

export const BASE_MAP_OPTIONS = [
  {
    id: 'openStreet',
    labelKey: 'MAP_TYPES.OPEN_STREET',
    fallbackLabel: 'Open Street',
    type: 'osm',
    img: MAP_SETTINGS_IMAGES.OPEN_STREET_LAYER
  },
  {
    id: 'googleRoadmap',
    labelKey: 'MAP_TYPES.GOOGLE_ROAD',
    fallbackLabel: 'Google Roadmap',
    type: 'roadmap',
    img: MAP_SETTINGS_IMAGES.GOOGLE_ROADMAP_LAYER
  },
  {
    id: 'googleSatellite',
    labelKey: 'MAP_TYPES.GOOGLE_SAT',
    fallbackLabel: 'Google Satellite',
    type: 'satellite',
    img: MAP_SETTINGS_IMAGES.GOOGLE_SATELLITE_LAYER
  },
  {
    id: 'googleHybrid',
    labelKey: 'MAP_TYPES.GOOGLE_HYB',
    fallbackLabel: 'Google Hybrid',
    type: 'hybrid',
    img: MAP_SETTINGS_IMAGES.GOOGLE_HYBRID_LAYER
  },
  {
    id: 'googleTerrain',
    labelKey: 'MAP_TYPES.GOOGLE_TER',
    fallbackLabel: 'Google Terrain',
    type: 'terrain',
    img: MAP_SETTINGS_IMAGES.GOOGLE_TERRAIN_LAYER
  }
]

const ShareImageMapSettings = ({
  selectedBaseMap = 'googleHybrid',
  onSelectBaseMap = () => {},
  isHeatmapActive = false,
  onToggleHeatmap = () => {},
  t = (s) => s
}) => {
  return (
    <div className='share-image-edit-controls'>
      {/* Base Map Selector Section */}
      <div className='share-image-controls-section'>
        <div className='share-image-controls-label'>
          {t('MAP_SETTINGS.BASE_MAP') || 'Base Map'}
        </div>
        <div className='share-image-basemap-list'>
          {BASE_MAP_OPTIONS.map((layer) => {
            const isSelected = selectedBaseMap === layer.id
            const labelText = t(layer.labelKey) || layer.fallbackLabel
            return (
              <div
                key={layer.id}
                className={`share-image-basemap-item ${isSelected ? 'share-image-basemap-item--selected' : ''}`}
                onClick={() => onSelectBaseMap(layer.id)}
                title={labelText}
              >
                <div className='share-image-basemap-thumb'>
                  <img
                    src={layer.img}
                    alt={labelText}
                    loading='lazy'
                  />
                </div>
                <span className='share-image-basemap-name'>{labelText}</span>
              </div>
            )
          })}
        </div>
      </div>

      {/* Overlays / Heatmap Toggle Section */}
      <div className='share-image-controls-section share-image-controls-section--heatmap'>
        <div className='share-image-controls-label'>
          {t('MAP_SETTINGS.OVERLAYS') || 'Overlays'}
        </div>
        <button
          type='button'
          className={`share-image-heat-btn ${isHeatmapActive ? 'share-image-heat-btn--active' : ''}`}
          onClick={onToggleHeatmap}
          title={isHeatmapActive ? 'Disable Heat Map' : 'Enable Heat Map'}
        >
          <div className='share-image-heat-thumb'>
            <img src={MAP_SETTINGS_IMAGES.HEAT_MAP} alt='Heatmap' />
          </div>
          <div className='share-image-heat-meta'>
            <span className='share-image-heat-title'>
              {t('MAP_SETTINGS.HEAT') || 'Heat Map'}
            </span>
            <span className='share-image-heat-subtitle'>
              {isHeatmapActive ? (t('GLOBAL.ON') || 'Active') : (t('GLOBAL.OFF') || 'Off')}
            </span>
          </div>
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(ShareImageMapSettings)
